import React from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Helmet } from 'react-helmet';
import Divider from '@material-ui/core/Divider';
import Footer from '../../Components/Layout/Footer';
import Routes from '../../Routing/Routes';
import Seo from '../../Routing/Seo';

import LayoutStyles from '../../Components/Layout/Styles/LayoutStyles';

type Props = {
  classes: Object,
};

const styles = () => ({
  layout: {
    ...LayoutStyles.centered800Layout,
    marginTop: '100px',
  },
});

function Mention({ classes }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        {Seo.title(`Mentions légales${t(`${Routes.currentNamespace()}.SEO.SUFFIX`)}`)}
        {Seo.description('La société')}
        {Seo.canonical(null, Routes.mentionUrl())}
      </Helmet>
      <Grid container className={classes.container}>
        <div className={classes.layout}>
          <Typography
            variant="h1"
            align="left"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.MENTION.TITLE'),
            }}
          />

          <Divider light style={{ margin: '20px', background: 'none' }} />

          <Typography
            variant="h6"
            style={{ marginBottom: -8, fontWeight: 900 }}
            dangerouslySetInnerHTML={{
              __html: t('WELLO.MENTION.DIRECTOR.TITLE'),
            }}
          />
          <Typography
            gutterBottom
            style={{ textAlign: 'justify' }}
            dangerouslySetInnerHTML={{
              __html: t(
                `${Routes.currentNamespace()}.MENTION.DIRECTOR.CONTENT`,
                t('WELLO.MENTION.DIRECTOR.CONTENT'),
              ),
            }}
          />

          <Divider light style={{ margin: '20px', background: 'none' }} />

          <Typography
            style={{ marginBottom: -8, fontWeight: 900 }}
            variant="h6"
            dangerouslySetInnerHTML={{
              __html: t('WELLO.MENTION.EDITOR.TITLE'),
            }}
          />
          <Typography
            gutterBottom
            style={{ textAlign: 'justify' }}
            dangerouslySetInnerHTML={{
              __html: t(
                `${Routes.currentNamespace()}.MENTION.EDITOR.CONTENT`,
                t('WELLO.MENTION.EDITOR.CONTENT'),
              ),
            }}
          />

          <Divider light style={{ margin: '20px', background: 'none' }} />

          <Typography
            style={{ marginBottom: -8, fontWeight: 900 }}
            variant="h6"
            dangerouslySetInnerHTML={{
              __html: t('WELLO.MENTION.HOST.TITLE'),
            }}
          />
          <Typography
            gutterBottom
            style={{ textAlign: 'justify' }}
            dangerouslySetInnerHTML={{
              __html: t(
                `${Routes.currentNamespace()}.MENTION.HOST.CONTENT`,
                t('WELLO.MENTION.HOST.CONTENT'),
              ),
            }}
          />

          <Grid item md={12} style={{ padding: '60px' }} align="middle">
            <Button component="a" href="/">
              <Typography
                variant="subtitle2"
                color="textPrimary"
                component="p"
                dangerouslySetInnerHTML={{
                  __html: t('BACK'),
                }}
              />
            </Button>
          </Grid>
        </div>
      </Grid>
      <Footer />
    </>
  );
}

export default withStyles(styles)(Mention);
